import { useEffect, useRef } from "react";
import { affiliateService } from "../../services/affiliate.service";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";

export function InvitationNotifications() {
  const hasChecked = useRef(false);

  useEffect(() => {
    // Skip if already checked in this session
    if (hasChecked.current) return;

    const checkInvitations = async () => {
      try {
        const invites = await affiliateService.getAffiliateInvitations();
        hasChecked.current = true;

        // Show notification if there are pending invitations
        const pendingInvites = invites.filter(
          (invite) => invite.status === "PENDING"
        );

        if (pendingInvites.length > 0) {
          toast(
            (t) => (
              <div>
                <p className="font-medium">
                  You have {pendingInvites.length} pending invitation
                  {pendingInvites.length > 1 ? "s" : ""}!
                </p>
                <div className="mt-2">
                  <Link
                    to="/affiliate/invitations"
                    className="text-brand-600 hover:text-brand-500 font-medium text-sm"
                    onClick={() => toast.dismiss(t.id)}
                  >
                    View Invitations
                  </Link>
                </div>
              </div>
            ),
            {
              duration: 5000,
              position: "top-right",
              id: "invitation-notification", // Add unique ID to prevent duplicates
            }
          );
        }
      } catch (error) {
        console.error("Failed to fetch invitations:", error);
      }
    };

    checkInvitations();

    // Cleanup function to dismiss any remaining toasts when component unmounts
    return () => {
      toast.dismiss("invitation-notification");
    };
  }, []); // Empty dependency array since we only want this to run once

  return null;
}
